import { ReactNode } from "react";

import { OrganizationStatus } from "@organization/models/OrganizationDetails";

import CheckCircleIcon from "@icons/checkCircle.svg?react";
import CloseCircleIcon from "@icons/closeCircle.svg?react";

interface Props {
  status: OrganizationStatus | undefined;
}

export const OrganizationStatusIcon = ({ status }: Props): ReactNode => {
  if (!status) {
    return <span data-testid="no-organization-status"></span>;
  }

  let element: ReactNode = null;

  switch (status) {
    case OrganizationStatus.Active:
      element = <CheckCircleIcon className="inline" />;
      break;

    case OrganizationStatus.Inactive:
      element = <CloseCircleIcon className="inline" />;
      break;
  }

  return (
    <span data-testid="organization-status-icon">
      {element} <span>{status}</span>
    </span>
  );
};
